import type { CompareProduct, TechSpecGroup } from '../types';
import { renderCompareRow } from './render-compare-row';

type RenderCompareGroupParams = {
  groupName: string;
  labels: string[];
  products: CompareProduct[];
  maxCompare: number;
  approximatePriceRow?: string;
};

export function renderCompareGroup({
  groupName,
  labels,
  products,
  maxCompare,
  approximatePriceRow = '',
}: RenderCompareGroupParams): string {
  const rowsHtml = labels
    .map((label) => {
      let hasAnyValue = false;

      const values = products.map((product) => {
        let data: TechSpecGroup[] = product.techData || [];

        if (data.length === 0) {
          const el = document.getElementById(`tech-data-${product.id}`);

          if (el) {
            try {
              data = JSON.parse(el.textContent || '[]');
            } catch {
              data = [];
            }
          }
        }

        let value = '—';

        const group = data.find((g) => g.group_name === groupName);

        const spec = group?.specs.find((s) => s.label === label);

        const raw = spec?.value?.toString().trim() || '';

        if (raw && raw !== '-' && raw !== '—') {
          value = raw;
          hasAnyValue = true;
        }

        return value;
      });

      if (!hasAnyValue) {
        return '';
      }

      return renderCompareRow({
        label,
        values,
        productsLength: products.length,
        maxCompare,
      });
    })
    .join('');

  if (!rowsHtml.trim()) {
    return '';
  }

  return `
    <div class="compare-group">
      <div class="heading-xs px-4x pt-6x pb-2x rounded-s tracking-wider">
        ${groupName}
      </div>

      ${approximatePriceRow}

      ${rowsHtml}
    </div>
  `;
}
